const Catalogue = () => import("./views/Catalogue.vue");
import DashboardLayout from "../../../views/Layout/DashboardLayout.vue";

const moduleRoute = {
  path: "/",
  component: DashboardLayout,
  children: [
    {
      path: "/catalogue",
      component: Catalogue,
      name: "Catalogue",
      meta: {
        groupName: "Auction",
      },
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
